import React from 'react';
import { useSelector } from 'react-redux';
import Ticker from '../../../components/common/Ticker/TickerLogo';
import { toDollarSmall, toDollar } from '../../../helpers/helperFunctions';

const TickerPrice = () => {

  const rate = useSelector(state => state.rate)
  const multicrypto = useSelector(state => state.multicrypto)

  return(
    <Ticker
      logo={`/assets/coins/${multicrypto.coin ? multicrypto.coin.ticker.toUpperCase() : 'BTC'}.png`}
      content={` $${
        multicrypto.coin ? rate.multicrypto_rates[multicrypto.coin.name.toLowerCase()] ? toDollarSmall(rate.multicrypto_rates[multicrypto.coin.name.toLowerCase()].price) : null : toDollarSmall(rate.price)}`} 
      chainLogo={multicrypto.coin ? multicrypto.coin.is_token ? multicrypto.coin.chain ? `/assets/chains/${multicrypto.coin.chain.name.toUpperCase()}.png` : null : null : null}
    />
  )
}

export default TickerPrice;
